// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 引入echarts
import * as echarts from 'echarts'
import {messageTooltip} from '@/utils/messageUtil'
import * as filters from '@/filters';
import BaiduMap from 'vue-baidu-map'

import Clipboard from 'clipboard';
Vue.prototype.Clipboard=Clipboard;
// import 'lib-flexible/flexible'
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
Vue.prototype.$echarts = echarts
Vue.prototype.messageTooltip = messageTooltip
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.config.ignoredElements = ['wx-open-launch-weapp']
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'xxxxxxxxxxxxxxxx'
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js